<template>
	<JBox>
		<MonacoEditor
			ref="monacoEditor"
			:value="computedValue"
			@change="onChange"
			:language="language"
			theme="vs-dark"
			:options="editorOptions"
			@editorDidMount="editorDidMount"
			class="s-h-full"
			:style="`height: ${height};`"
		/>
		<JSpinner type="dots" :delay="10" v-if="isMounting" />
	</JBox>
</template>

<script>
export default {
	components: {
		MonacoEditor: () => import("vue-monaco")
	},

	props: {
		language: {
			type: String,
			default: () => "json"
		},
		value: {
			type: String
		},
		readOnly: {
			type: Boolean,
			default: () => false
		},
		height: {
			type: String,
			default: () => "200px"
		}
	},

	data() {
		return {
			isMounting: true, // it take some time to mount the editor
			editorOptions: {
				autoIndent: true,
				automaticLayout: true,
				autoClosingBrackets: true,
				formatOnPaste: false,
				formatOnType: false,
				tabCompletion: true,
				readOnly: this.readOnly,
				minimap: {
					enabled: false
				}
			}
		}
	},
	methods: {
		onChange(value) {
			this.$emit("input", value === "" ? null : value)
		},

		editorDidMount(editor) {
			this.isMounting = false
			this.$emit("editorDidMount", editor)
		}
	},

	computed: {
		computedValue() {
			return this.value === null ? "" : this.value
		}
	}
}
</script>
